import { getExtStatus, userSign, hangUp, callOutCancel } from '../../api/CallCenter'; // 呼叫中心
import { message } from 'antd'
import { CRM_CALLCENTER_INFO } from "../../util/keys";
import { getYiXunAgentStatus, YiXunAgentLogin, YiXunAgentLogoff, YiXunQueuePause, YiXunHangup} from "../../util/YiXunCallCenter";
import { getsubjectdictbytype } from "../../api/RefundInterface";

export const type = {
    CRM_MENU: 'CRM_MENU', // 运营系统菜单
    SIDEBAR_MENU: 'SIDEBAR_MENU', // 侧边栏导航
    SWITCH_MENU: 'SWITCH_MENU',
    REPORT_SEARCH: 'REPORT_SEARCH',
    CAMPUS_SEARCH: 'CAMPUS_SEARCH',
    OURSCHOOL_SEARCH: 'OURSCHOOL_SEARCH',
    YIXUN_REXTEND: 'YIXUN_REXTEND', // 易迅扩展字段
    CALL_STATUS: 'CALL_STATUS',
    AD_INFO: 'AD_INFO', // 公告消息
    SALECENTER_POTENTIAL: 'SALECENTER_POTENTIAL', // 销售中心-潜在学员搜索条件
    DingClass_Params :'DingClass_Params', //钉钉所在班级搜索条件
    DingStudent_Params :'DingStudent_Params', //钉钉所在学员搜索条件
    SALECENTER_READING: 'SALECENTER_READING', // 销售中心-在读学员搜索条件
    SALECENTER_HISTORICAL: 'SALECENTER_HISTORICAL', // 销售中心-历史学员搜索条件
    EC_READING: 'EC_READING', // 教务中心-在读学员搜索条件
    EC_HISTORICAL: 'EC_HISTORICAL', // 教务中心-历史学员搜索条件
    ORDERMANAGE_SEARCH: 'ORDERMANAGE_SEARCH', // 教务中心-历史学员搜索条件
    CLASSLESSON_SEARCH: 'CLASSLESSON_SEARCH', // 教务中心-班级课程搜索条件
    SIDER_CUSTOM: 'SIDER_CUSTOM', // 三级菜单
    READY_COURSE_DATE: 'READY_COURSE_DATE', //备课磨课日期
    IS_SHOW_CASE_INFO: 'IS_SHOW_CASE_INFO',//是否预览
    CANSE_MANAGE_SEARCH: 'CANSE_MANAGE_SEARCH',//案例管理
    HEADQUARTERS_SEARCH: 'HEADQUARTERS_SEARCH', //总部搜索
    City_Search: 'City_Search', //市搜索
    ACTIVATIONPOINTCOUNT:'ACTIVATIONPOINTCOUNT'
}

export function SetActivationPointCount(num) {
    return {
        type: type.ACTIVATIONPOINTCOUNT,
        num,
    }
}

export function SetCrmMenu(CRM_MENU) {
    return {
        type: type.CRM_MENU,
        CRM_MENU,
    }
}
export function SetSideMenu(SideBarMenu, OpenKeys, SelectedKeys, ActiveKey) {
    // console.log("SideBarMenu", SideBarMenu)
    return {
        type: type.SIDEBAR_MENU,
        SideBarMenu,
        OpenKeys,
        SelectedKeys,
        ActiveKey
    }
}

export function switchMenu(OpenKeys, SelectedKeys) {
    return {
        type: type.SWITCH_MENU,
        OpenKeys,
        SelectedKeys
    }
}

export function ReportSearch(FillInReportSearch) {
    return {
        type: type.REPORT_SEARCH,
        FillInReportSearch
    }
}

export function CampusSearch(CampusInfoSearch) {
    return {
        type: type.CAMPUS_SEARCH,
        CampusInfoSearch
    }
}

export function OurSchoolSearch(OurSchoolInfoSearch) {
    return {
        type: type.OURSCHOOL_SEARCH,
        OurSchoolInfoSearch
    }
}

// 呼叫中心 status



export function ChangeCallStatus(CallCenterStatus) {
    return {
        type: type.CALL_STATUS,
        CallCenterStatus,
        CallCenterStatusName: ['未签入', '空闲中', '忙碌中', '通话中'][CallCenterStatus - 1],
    }
}
export function CallOutRextend(YiXunRextend) {
    return {
        type: type.YIXUN_REXTEND,
        YiXunRextend,
    }

}
export function CallCenterStatus(CallCenterStatus, CallCenterStatusName) {
    let CallCenterInfo = JSON.parse(localStorage.getItem(CRM_CALLCENTER_INFO) || '{}'),
        CallCenterType = CallCenterInfo.callCenterType
    return dispatch => {
        switch (CallCenterStatus) {
            case 'signIn': // 签入
                if ((CallCenterType === "3") || (CallCenterType === "4")) {
                    userSign({ operate: 1, operateType: 1 }).then(ret => {
                        getExtStatus().then(res => {
                            if (res.code === 0) {
                                (res.data.statusId === 2) ? message.success('签入成功') : message.success(['未签入', '空闲中', '忙碌中', '通话中'][res.data.statusId - 1])
                                dispatch(ChangeCallStatus(res.data.statusId))
                            }
                        })
                    })
                } else if (CallCenterType === '5') {
                    YiXunAgentLogin().then(ret => {
                        getYiXunAgentStatus()
                    })
                } else {
                    console.error(`无效的话务类型：CallCenterType === ${CallCenterType};CallCenterTypeType === ${typeof (CallCenterType)}`)
                }
                break;
            case 'signOut': // 签出
                if ((CallCenterType === "3") || (CallCenterType === "4")) {
                    userSign({ operate: 2, operateType: 1 }).then(ret => {
                        getExtStatus().then(res => {
                            if (res.code === 0) {
                                (res.data.statusId === 1) ? message.success('签出成功') : message.success(['未签入', '空闲中', '忙碌中', '通话中'][res.data.statusId - 1])
                                dispatch(ChangeCallStatus(res.data.statusId))
                            }
                        })
                    })
                } else if (CallCenterType === '5') {
                    YiXunAgentLogoff().then(ret => {
                        getYiXunAgentStatus()
                    })
                } else {
                    console.error(`无效的话务类型：CallCenterType === ${CallCenterType};CallCenterTypeType === ${typeof (CallCenterType)}`)
                }
                break;
            case 'setIdle': // 置闲
                if ((CallCenterType === "3") || (CallCenterType === "4")) {
                    userSign({ operate: 4, operateType: 2 }).then(ret => {
                        getExtStatus().then(res => {
                            if (res.code === 0) {
                                (res.data.statusId === 2) ? message.success('置闲成功') : message.success(['未签入', '空闲中', '忙碌中', '通话中'][res.data.statusId - 1])
                                dispatch(ChangeCallStatus(res.data.statusId))
                            }
                        })
                    })
                } else if (CallCenterType === '5') {
                    YiXunQueuePause(false).then(ret => {
                        getYiXunAgentStatus()
                    })
                } else {
                    console.error(`无效的话务类型：CallCenterType === ${CallCenterType};CallCenterTypeType === ${typeof (CallCenterType)}`)
                }
                break;
            case 'setBusy': // 置忙
                if ((CallCenterType === "3") || (CallCenterType === "4")) {
                    userSign({ operate: 3, operateType: 2 }).then(ret => {
                        getExtStatus().then(res => {
                            if (res.code === 0) {
                                (res.data.statusId === 3) ? message.success('置忙成功') : message.success(['未签入', '空闲中', '忙碌中', '通话中'][res.data.statusId - 1])
                                dispatch(ChangeCallStatus(res.data.statusId))
                            }
                        })
                    })
                } else if (CallCenterType === '5') {
                    YiXunQueuePause(true).then(ret => {
                        getYiXunAgentStatus()
                    })
                } else {
                    console.error(`无效的话务类型：CallCenterType === ${CallCenterType};CallCenterTypeType === ${typeof (CallCenterType)}`)
                }
                break;
            case 'setHangup': // 挂断
                if ((CallCenterType === "3") || (CallCenterType === "4")) {
                    if ( CallCenterType - 3 === 0 ) {
                        callOutCancel().then(ret => {
                            if (ret.code === 0) {
                                dispatch({
                                    type: type.CALL_STATUS,
                                    CallCenterStatus: 2,
                                    CallCenterStatusName: '空闲中',
                                })
                            }
                        })
                    }
                    hangUp({
                        callCenterType: CallCenterType,
                        extNo: CallCenterInfo.bindPhone
                    }).then(ret => {
                        if (ret.code === 0) {
                            dispatch({
                                type: type.CALL_STATUS,
                                CallCenterStatus: 2,
                                CallCenterStatusName: '空闲中',
                            })
                        }
                    })
                } else if (CallCenterType === '5') {
                    YiXunHangup(true).then(ret => {
                        getYiXunAgentStatus()
                    })
                } else {
                    console.error(`无效的话务类型：CallCenterType === ${CallCenterType};CallCenterTypeType === ${typeof (CallCenterType)}`)
                }
                break;
            case 'callOut': // 外呼
                dispatch({
                    type: type.CALL_STATUS,
                    CallCenterStatus: 4,
                    CallCenterStatusName: '通话中',
                })
                break;
            default:
                dispatch({
                    type: type.CALL_STATUS,
                    CallCenterStatus: 1,
                    CallCenterStatusName: '未签入',
                })
                break
        }
    }
}

// 获取学科配置study
export function getsubjectdict(type) {
    return dispatch => {
        getsubjectdictbytype({
            queryType: type,
            clientCode:'SQUIRREL_AI_HARDWARE_TOB',//固定项目一级code
            systemCode: 'CLIENT_SQUIRREL_AI_HARDWARE_DISTRIBUTOR',//固定项目二级code
        }).then((res)=>{
            if(res.code == 0 && res.data){
                let list = []
                res.data.forEach(item => {
                    list.push({
                      id: item.subjectId,
                      name: item.subjectName
                    })
                });
                if(type == 1){
                    localStorage.setItem('stuySubjectDict',JSON.stringify(list))
                }else{
                    localStorage.setItem('agentSubjectDict',JSON.stringify(list))
                }
            }
        })
    }
}

// 公告消息
export function Advertisement (AdvertisementInfo) {
    return {
        type: type.AD_INFO,
        AdvertisementInfo,
    }
}

// 销售中心-潜在学员搜索条件
export function recordSaleCenterPotential (SaleCenter_Potential) {
    return {
        type: type.SALECENTER_POTENTIAL,
        SaleCenter_Potential
    }
}
// 钉钉班级 搜索条件
export function DingClassParams (DingClass_Params) {
    return {
        type: type.DingClass_Params,
        DingClass_Params
    }
}
// 钉钉学员 搜索条件
export function DingStudentParams (DingStudent_Params) {
    return {
        type: type.DingStudent_Params,
        DingStudent_Params
    }
}
// 销售中心-在读学员搜索条件
export function recordSaleCenterReading (SaleCenter_Reading) {
    return {
        type: type.SALECENTER_READING,
        SaleCenter_Reading
    }
}

// 销售中心-历史学员搜索条件
export function recordSaleCenterHistorical (SaleCenter_Historical) {
    return {
        type: type.SALECENTER_HISTORICAL,
        SaleCenter_Historical
    }
}

// 教务中心-在读学员搜索条件
export function recordECReading (EC_Reading) {
    return {
        type: type.EC_READING,
        EC_Reading
    }
}

// 教务中心-历史学员搜索条件
export function recordECHistorical (EC_Historical) {
    return {
        type: type.EC_HISTORICAL,
        EC_Historical
    }
}

// 订单管理搜索条件
export function recordOrderManage (OrderManage_Search) {
    return {
        type: type.ORDERMANAGE_SEARCH,
        OrderManage_Search
    }
}

// 订单管理搜索条件
export function recordClassLesson (ClassLessonSearch) {
    return {
        type: type.CLASSLESSON_SEARCH,
        ClassLessonSearch
    }
}
// 订单管理搜索条件
export function changeNavigationList (navigationList) {
    return {
        type: type.SIDER_CUSTOM,
        navigationList
    }
}
// 备课磨课时间
export function readyCourseDate (RC_Date) {
    return {
        type: type.READY_COURSE_DATE,
        RC_Date
    }
}
// 公海池
export function HighSEACH (HighSeasSearch) {
    return {
        type: type.HEADQUARTERS_SEARCH,
        HighSeasSearch
    }
}
// 公海池
export function MarketSEACH (CitySearch) {
    return {
        type: type.City_Search,
        CitySearch
    }
}

//判断关闭预览
export function isShowCaseInfo (isShowInfo) {
    return {
        type: type.IS_SHOW_CASE_INFO,
        isShowInfo
    }
}
// 案例管理筛选条件
export function caseManageSearchInfo (searchInfo) {
    return {
        type: type.CANSE_MANAGE_SEARCH,
        searchInfo
    }
}



